import {
  PlannerConfigEntityWithOptionalFields,
  PlannerConfigMarketDataEntity,
} from '@/services/configurator/PlannerConfigTypes';
import { ControllerRenderProps } from 'react-hook-form';
import { PlannerFormItemMarketDataDialogProps } from './planner-form-market-data-dialog';

export type HandleChangeProps = {
  fieldName: keyof PlannerConfigMarketDataEntity;
  value: PlannerConfigMarketDataEntity[keyof PlannerConfigMarketDataEntity];
  field: ControllerRenderProps<PlannerConfigEntityWithOptionalFields>;
  props: PlannerFormItemMarketDataDialogProps;
  marketIndex: number;
};

export function handleChange({
  fieldName,
  value,
  field,
  props,
  marketIndex,
}: HandleChangeProps) {
  if (!props.marketData) {
    return null;
  }

  const updatedMarketData = [...props.marketData];

  if (marketIndex >= 0) {
    updatedMarketData[marketIndex] = {
      ...updatedMarketData[marketIndex],
      [fieldName]: value,
    };
  } else {
    updatedMarketData.push({
      includeDeeplinkParams: true,
      locale: props.currentMarket,
      [fieldName]: value,
      isActive: true,
      imageUrl: '',
      videoUrl: '',
      primaryCardCtaUrl: '',
      secondaryBannerCtaUrl: '',
      secondaryBannerImgUrl: '',
      secondaryCardCtaUrl: '',
      productsInclude: [],
      productsExclude: [],
      rangeInclude: [],
      rangeExclude: [],
      bannerLargeMode: undefined,
      videoPosterUrl: undefined,
    });
  }

  // Update the field value in react-hook-form
  field.onChange(value);
}

export const formFields: {
  name: keyof PlannerConfigMarketDataEntity;
  label: string;
  description?: string;
  hasPreview?: boolean;
}[] = [
  {
    name: 'imageUrl',
    label: 'Image Url',
    description:
      'Example url: https://www.ikea.com/ext/ingkadam/m/1a22eed59a379d0d/original/PH188297.jpg',
    hasPreview: true,
  },
  {
    name: 'videoUrl',
    label: 'Video Url',
    description:
      'Example url: https://www.ikea.com/ext/ingkadam/m/7c5c2e0b5b3d12cb/original/692511_EKET_WEB_1x1.mp4',
    hasPreview: true,
  },
  {
    name: 'videoPosterUrl',
    label: 'Video Poster Url',
    description:
      'Poster image shown before the video plays. Example url: https://www.ikea.com/ext/ingkadam/m/1a22eed59a379d0d/original/PH188297.jpg',
    hasPreview: true,
  },
  { name: 'primaryCardCtaUrl', label: 'Primary card cta url' },
  { name: 'secondaryBannerCtaUrl', label: 'Secondary banner cta url' },
  {
    name: 'secondaryBannerImgUrl',
    label: 'Secondary banner image url',
    description:
      'Example url: https://www.ikea.com/ext/ingkadam/m/1a22eed59a379d0d/original/PH188297.jpg',
    hasPreview: true,
  },
  { name: 'secondaryCardCtaUrl', label: 'Secondary card cta url' },
];

export const formFieldsArray: {
  name: keyof PlannerConfigMarketDataEntity;
  label: string;
  description?: string;
}[] = [
  {
    name: 'productsInclude',
    label: 'Products Include',
  },
  {
    name: 'productsExclude',
    label: 'Products Exclude',
  },
  {
    name: 'rangeExclude',
    label: 'Categories Exclude',
  },
  {
    name: 'rangeInclude',
    label: 'Categories Include',
  },
];
